/**
 * JWT token generator for app-key header
 */

let encrypted = '';

// Helper to get env var from either process.env (Node.js) or import.meta.env (Vite)
const getEnv = (key: string): string | undefined => {
    // Check for Node.js environment
    if (typeof process !== 'undefined' && process.env) {
        return process.env[key];
    }
    // For webpack builds (plugin), environment variables are replaced at build time
    // via DefinePlugin, so we can't use dynamic access to import.meta
    // The caller should use direct property access instead
    return undefined;
};

export async function initializeJWT() {
    try {
        // Use direct property access for webpack DefinePlugin compatibility
        let secret: string | undefined;
        let secret_data: string | undefined;
        
        try {
            secret = (import.meta.env as any).VITE_AT_SECRET;
            secret_data = (import.meta.env as any).VITE_AT_SECRET_DATA;
        } catch {
            // Fallback to process.env for Node.js environments
            secret = getEnv('AT_SECRET');
            secret_data = getEnv('AT_SECRET_DATA');
        }

        if (secret && secret_data) {
            // Dynamic import for jwt-encode to avoid bundling issues
            const sign = require('jwt-encode');
            encrypted = sign(secret_data, secret);
        }
    } catch (error) {
        console.error('Error initializing JWT:', error);
    }
}

export function getEncryptedToken(): string {
    return encrypted;
}

// Initialize JWT on module load
initializeJWT();

